var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2538_824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C4.89543 4 4 4.89543 4 6V34C4 35.1046 4.89543 36 6 36H34C35.1046 36 36 35.1046 36 34V6C36 4.89543 35.1046 4 34 4H6ZM12.484 17.644V16H7V24.424H9.052V21.016H11.62V19.42H9.052V17.644H12.484ZM16.1065 21.244L17.8585 24.424H20.1745L18.2305 21.088C18.8465 20.904 19.3105 20.592 19.6225 20.152C19.9425 19.712 20.1025 19.212 20.1025 18.652C20.1025 18.156 19.9865 17.708 19.7545 17.308C19.5225 16.9 19.1705 16.58 18.6985 16.348C18.2345 16.116 17.6705 16 17.0065 16H13.5625V24.424H15.6145V21.244H16.1065ZM16.8865 19.792H15.6145V17.704H16.8865C17.2625 17.704 17.5425 17.796 17.7265 17.98C17.9185 18.164 18.0145 18.416 18.0145 18.736C18.0145 19.072 17.9185 19.332 17.7265 19.516C17.5425 19.7 17.2625 19.792 16.8865 19.792ZM23.4426 17.644V19.348H26.1906V20.932H23.4426V22.78H26.5506V24.424H21.3906V16H26.5506V17.644H23.4426ZM29.9348 19.348V17.644H33.0428V16H27.8828V24.424H33.0428V22.78H29.9348V20.932H32.6828V19.348H29.9348Z",
    fill: "#F8D210"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2538_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.91e954154353cbdd9ae39e2199e14e2f.svg";
export { ForwardRef as ReactComponent };